import { InputTypes, UI, HStack } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { KeyboardAvoidingView, Pressable, IPressableProps } from 'native-base';
import React from 'react';
import { Control, FieldValues } from 'react-hook-form';
import { NativeSyntheticEvent, Platform, TextInputFocusEventData } from 'react-native';

import { InputClearIcon } from '../InputClearIcon';
import { InputEditIcon } from '../InputEditIcon';

export interface InputMoneyProps {
  id: string;
  name: string;
  hasFocus: boolean;
  control: Control<FieldValues>;
  minValue: number;
  currentValue: string;
  handleFocus: () => void;
  handleBlur: (e: NativeSyntheticEvent<TextInputFocusEventData>) => void;
  handleSubmit: () => void;
  handleClear: () => void;
  isDisabled?: boolean;
  customInputProps?: Partial<InputTypes.Props>;
  customPressableProps?: Partial<IPressableProps>;
  hideEditIconOnDisabled?: boolean;
}

export const InputMoney: React.FC<InputMoneyProps> = ({
  id,
  name,
  hasFocus,
  control,
  minValue,
  currentValue,
  handleFocus,
  handleBlur,
  handleSubmit,
  handleClear,
  isDisabled,
  customInputProps,
  customPressableProps,
  hideEditIconOnDisabled,
}) => {
  return (
    <KeyboardAvoidingView {...(Platform.OS === 'ios' && { behavior: 'padding' })} w="full" flex={1}>
      {hasFocus ? (
        <UI.Input
          isDisabled={isDisabled}
          autoFocus={hasFocus}
          onFocus={handleFocus}
          onBlur={handleBlur}
          editable={hasFocus}
          keyboardType="numeric"
          onClick={handleFocus}
          testID={`input-application-amount-${id}`}
          onSubmitEditing={handleSubmit}
          name={name}
          control={control}
          autoComplete="off"
          hasShadow={false}
          variant="filled"
          mask={Utils.Mask.InputMoney}
          placeholder={Utils.Mask.Money(minValue)}
          {...(!hasFocus ? { color: Color['neutral.light'] } : {})}
          {...(hasFocus
            ? { inputRightElement: <InputClearIcon onPress={handleClear} /> }
            : {
                inputRightElement: <InputEditIcon onPress={handleClear} disabled={isDisabled} />,
              })}
          {...customInputProps}
        />
      ) : (
        <Pressable
          onPress={handleFocus}
          bg="backgroundshade"
          _hover={{
            borderColor: Color['brand.tertiary.principal'],
          }}
          isDisabled={isDisabled}
          testID={`button-edit-application-amount-${id}`}
          borderWidth={1}
          borderColor={'transparent'}
          justifyContent={'center'}
          alignItems={'center'}
          height="38px"
          px={'10px'}
          py={'12px'}
          borderRadius={'4px'}
          w={'100%'}
          {...customPressableProps}>
          <HStack w={'100%'} alignItems={'center'} justifyContent={'space-between'}>
            <UI.Text variant="regular" color={'neutral.light'} fontSize={Typography['fontsize.lg']}>
              {currentValue}
            </UI.Text>
            {!hideEditIconOnDisabled && (
              <UI.Icon name="EditPen" size="xxxs" color={Color['brand.tertiary.principal']} />
            )}
          </HStack>
        </Pressable>
      )}
    </KeyboardAvoidingView>
  );
};
